import { useState } from "react";
import { Modal } from "../../../theme/Component/Modal";
import { BasicButton } from "../../../theme/Component/BasicButton";

export const TransportGuideMetodo = () => {

    const [lista, setLista] = useState<any[]>([]);
    const [editIndex, setEditIndex] = useState<number | null>(null);
    const [isEditing, setIsEditing] = useState(false);

    const [modal, setModal] = useState<any>({
        view: false,
        btnClose: true,
        btnSubmit: true,
        format: "modal-md"
    });

    const [form, setForm] = useState<any>({
        IDUBLPaymentMeansCode: "",
        PaymentMeansCode: "",
        Description: "",
        IDUBLPaymentMeans: ""
    });

    const create = () => {

        setIsEditing(false);
        setEditIndex(null);

        setForm({
            IDUBLPaymentMeansCode: "",
            PaymentMeansCode: "",
            Description: "",
            IDUBLPaymentMeans: ""
        });

        setModal({ ...modal, view: true });
    };

    const editar = (index: number) => {

        const item = lista[index];

        setForm({
            IDUBLPaymentMeansCode: item.IDUBLPaymentMeansCode,
            PaymentMeansCode: item.PaymentMeansCode,
            Description: item.Description,
            IDUBLPaymentMeans: item.IDUBLPaymentMeans
        });

        setEditIndex(index);
        setIsEditing(true);

        setModal({ ...modal, view: true });
    };

    const limpiarTabla = () => {
        if (window.confirm("¿Desea limpiar todos los registros de la tabla?")) {
            setLista([]);
        }
    };

    const guardar = () => {

        if (isEditing && editIndex !== null) {

            const nuevaLista = [...lista];

            nuevaLista[editIndex] = {
                ...nuevaLista[editIndex],
                IDUBLPaymentMeansCode: form.IDUBLPaymentMeansCode,
                PaymentMeansCode: form.PaymentMeansCode,
                Description: form.Description,
                IDUBLPaymentMeans: form.IDUBLPaymentMeans
            };

            setLista(nuevaLista);

        } else {

            const nuevo = {
                IDUBLPaymentMeansCode: lista.length + 1,
                PaymentMeansCode: form.PaymentMeansCode,
                Description: form.Description,
                IDUBLPaymentMeans: form.IDUBLPaymentMeans
            };

            setLista([...lista, nuevo]);
        }

        setModal({ ...modal, view: false });
    };

    return (

        <div className="container">

            <div className="col-md-12">
                <label>Medios de Pago</label>
            </div>

            <div className="row mb-3 mt-4">

                <div className="col-md-3">
                    <button
                        className="btn btn-primary"
                        onClick={create}
                    >
                        Agregar
                    </button>
                </div>

                <div className="col-md-3">
                    <button
                        className="btn btn-danger"
                        onClick={limpiarTabla}
                    >
                        Limpiar tabla
                    </button>
                </div>

            </div>

            <div className="row">
                <div className="col-md-12">

                    <table className="table table-striped">

                        <thead>
                            <tr className="table-encabezado">
                                <th>Acciones</th>
                                <th>ID</th>
                                <th>Código</th>
                                <th>Descripción</th>
                                <th>Forma de Pago</th>
                            </tr>
                        </thead>

                        <tbody>

                            {lista.length === 0 && (
                                <tr>
                                    <td colSpan={5} className="text-center">
                                        No hay registros
                                    </td>
                                </tr>
                            )}

                            {lista.map((item, index) => (
                                <tr key={index}>

                                    <td>
                                        <BasicButton
                                            icon="ri-more-2-line"
                                            clase="table-new"
                                            eventClick={() => editar(index)}
                                        />
                                    </td>

                                    <td>{item.IDUBLPaymentMeansCode}</td>
                                    <td>{item.PaymentMeansCode}</td>
                                    <td>{item.Description}</td>
                                    <td>{item.IDUBLPaymentMeans}</td>

                                </tr>
                            ))}

                        </tbody>

                    </table>

                </div>
            </div>

            <Modal modal={modal} updateModal={setModal} eventModal={guardar}>

                <div className="row">

                    <div className="col-md-6">
                        <label>Código</label>
                        <input
                            type="text"
                            className="form-control"
                            value={form.PaymentMeansCode}
                            onChange={(e) =>
                                setForm({ ...form, PaymentMeansCode: e.target.value })
                            }
                        />
                    </div>

                    <div className="col-md-6">
                        <label>Forma de Pago</label>
                        <input
                            type="text"
                            className="form-control"
                            value={form.IDUBLPaymentMeans}
                            onChange={(e) =>
                                setForm({ ...form, IDUBLPaymentMeans: e.target.value })
                            }
                        />
                    </div>

                    <div className="col-md-12">
                        <label>Descripción</label>
                        <textarea
                            className="form-control"
                            value={form.Description}
                            onChange={(e) =>
                                setForm({ ...form, Description: e.target.value })
                            }
                        />
                    </div>

                </div>

            </Modal>

        </div>

    );
};